import { render, staticRenderFns } from "./baseConsumable.vue?vue&type=template&id=38709256&"
import script from "./baseConsumable.vue?vue&type=script&lang=js&"
export * from "./baseConsumable.vue?vue&type=script&lang=js&"
import style0 from "./baseConsumable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports